
export const getSuccessUrl = (context) => {
  const isWaiverUpload = context.$route?.name === 'inscription-upload-waiver'
  const dynamicSuccessUrl = context?.dynamicFormTemplate?.successUrl
  const shouldUseStripeFallback = !isWaiverUpload && !dynamicSuccessUrl
  const successUrl = isWaiverUpload
    ? import.meta.env.VITE_UPLOAD_WAIVER_RETURN_URL
    : (dynamicSuccessUrl || import.meta.env.VITE_STRIPE_RETURN_URL)
  const url = new URL(successUrl, window.location.origin)

  if (shouldUseStripeFallback) {
    if (context?.organizationId) {
      url.searchParams.set('organizationId', context.organizationId)
    }
    if (context?.projectId) {
      url.searchParams.set('projectId', context.projectId)
    }
  }

  return url.toString()
};

export const redirectToSuccess = (context) => {
  const redirectUrl = getSuccessUrl(context)
  window.location.href = redirectUrl
};
